module.exports = __webpack_public_path__ + "img/pointd.0de945db.jpg";